module.exports = __webpack_public_path__ + "static/media/B4.15e82350.png";